var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-2" },
    [
      _c(
        "form",
        { attrs: { method: "POST" }, on: { submit: _vm.disablePassBtn } },
        [
          _c("input", {
            attrs: { type: "hidden", name: "_csrfToken" },
            domProps: { value: _vm.csrfToken }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "fail_reason" },
            domProps: { value: _vm.fail_reason }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "killer_question_status" },
            domProps: { value: _vm.killer_question_status }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-control border-0" },
            [
              _vm._l(
                _vm.jobApplication.job.requisition.person_specification
                  .killer_questions,
                function(killerQuestion, index) {
                  return _c(
                    "div",
                    {
                      key: "killer-question-" + killerQuestion.id,
                      staticClass: "mb-4 font-small"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-right": "8px",
                            color: "#455666"
                          }
                        },
                        [
                          _c("strong", { staticClass: "quesiton-title" }, [
                            _vm._v(
                              _vm._s(index + 1) +
                                ". " +
                                _vm._s(killerQuestion.title)
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(killerQuestion.killer_question_answers, function(
                        answer
                      ) {
                        return [
                          _vm.isChecked(answer.id)
                            ? _c(
                                "span",
                                {
                                  key: "anwswer-status-" + answer.id,
                                  class: answer.is_correct
                                    ? "badge-killer-question success"
                                    : "badge-killer-question fail"
                                },
                                [
                                  _vm._v(
                                    _vm._s(answer.is_correct ? "PASS" : "FAIL")
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isChecked(answer.id)
                            ? _c(
                                "div",
                                {
                                  key: "answer-title-" + answer.id,
                                  staticClass: "mt-2",
                                  staticStyle: { "font-size": ".9rem" }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(answer.title) +
                                      "\n                    "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("input", {
                            key: "killer-question-answe-" + answer.id,
                            staticStyle: { display: "none" },
                            attrs: {
                              disabled: true,
                              type: "radio",
                              id: "killer-question-answers-" + answer.id
                            },
                            domProps: { checked: _vm.isChecked(answer.id) }
                          })
                        ]
                      })
                    ],
                    2
                  )
                }
              ),
              _vm._v(" "),
              _c("hr", { staticStyle: { "max-width": "unset" } }),
              _vm._v(" "),
              _c("strong", { staticClass: "mr-3 text-uppercase" }, [
                _vm._v("Final Status: ")
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "badge-killer-question",
                  class: [
                    _vm.jobApplication.killer_question_status === "passed"
                      ? "bg-custom-green"
                      : "",
                    _vm.jobApplication.killer_question_status === "failed"
                      ? "fail"
                      : ""
                  ]
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.jobApplication.killer_question_status) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.logs !== null && _vm.logs !== ""
                ? _c("span", { staticClass: "text-uppercase" }, [
                    _vm._v(
                      "\n                 (UPDATED BY " +
                        _vm._s(_vm.logs.user.first_name) +
                        " " +
                        _vm._s(_vm.logs.user.last_name) +
                        " - " +
                        _vm._s(_vm.convertDate(_vm.logs.created)) +
                        ")\n            "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("hr", { staticStyle: { "max-width": "unset" } }),
              _vm._v(" "),
              _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "button px-5",
                      attrs: { type: "submit", disabled: _vm.passBtnDisabled }
                    },
                    [_vm._v("PASS")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell shrink" }, [
                  _c("button", {
                    ref: "failedButton",
                    staticClass: "d-none",
                    attrs: { value: "failed", name: "killer_question_status" }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button alert px-5",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.toggleModal("failModal")
                        }
                      }
                    },
                    [_vm._v("FAIL")]
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "button recycle px-5",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.toggleModal("recycleModal")
                        }
                      }
                    },
                    [_vm._v("RECYCLE")]
                  )
                ])
              ])
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("recycle-modal", {
        ref: "recycleModal",
        attrs: {
          "job-application": _vm.jobApplication,
          "csrf-token": _vm.csrfToken
        }
      }),
      _vm._v(" "),
      _c("fail-modal", {
        ref: "failModal",
        attrs: { "job-application": _vm.jobApplication },
        on: { submit: _vm.fail }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a05b73d6", { render: render, staticRenderFns: staticRenderFns })
  }
}